export default "__VITE_ASSET__3a33db67__"